import { render } from "./ExpandableSidebar.vue?vue&type=template&id=35808034&scoped=true"
import script from "./ExpandableSidebar.vue?vue&type=script&lang=js"
export * from "./ExpandableSidebar.vue?vue&type=script&lang=js"

import "./ExpandableSidebar.vue?vue&type=style&index=0&id=35808034&lang=scss"
import "./ExpandableSidebar.vue?vue&type=style&index=1&id=35808034&lang=scss&scoped=true"
import "./ExpandableSidebar.vue?vue&type=style&index=2&id=35808034&lang=scss&scoped=true"
import "./ExpandableSidebar.vue?vue&type=style&index=3&id=35808034&lang=scss&scoped=true"
import "./ExpandableSidebar.vue?vue&type=style&index=4&id=35808034&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35808034"]])

export default __exports__